export const productDevelopmentDashboardEs = {
  title: 'Desarrollo de producto',
  subtitle: 'Vista por rol de datos maestros, aprobaciones, producción y planificación.',
  help: 'Abrir la ayuda de desarrollo de producto',
  refresh: 'Actualizar el panel',
  generatedAt: 'Datos a fecha de {{date}}',
  loading: {
    title: 'Cargando el panel de desarrollo de producto',
    description: 'Se están calculando las señales actuales de flujo y planificación.',
  },
  error: {
    title: 'No se pudo cargar el panel',
    description: 'El servidor no pudo calcular las señales actuales de desarrollo de producto.',
    retry: 'Reintentar',
  },
  empty: {
    title: 'No hay indicadores disponibles para este rol',
    description: 'Su rol no tiene actualmente lectura sobre los dominios de datos del panel.',
  },
  cards: {
    OPEN_WORKFLOWS: {
      title: 'Revisiones y aprobaciones abiertas',
      description: 'Elementos que requieren una decisión profesional explícita.',
    },
    INCOMPLETE_MATERIALS: {
      title: 'Materias primas incompletas',
      description: 'Últimos perfiles sin aprobación, proveedor o nombres de declaración.',
    },
    DECLARATION_WARNINGS: {
      title: 'Avisos de declaración',
      description: 'Últimas declaraciones con errores, diferencias o idiomas ausentes.',
    },
    EXPIRING_VERSIONS: {
      title: 'Versiones próximas a vencer',
      description: 'Versiones fuente aprobadas que vencen en 30 días.',
    },
    UPCOMING_PRODUCTION_ORDERS: {
      title: 'Órdenes de producción próximas',
      description: 'Órdenes planificadas o liberadas que empiezan en 14 días.',
    },
    MATERIAL_SHORTAGES: {
      title: 'Faltantes de material',
      description: 'Propuestas abiertas de la última ejecución MRP reproducible.',
    },
    PRODUCTION_DEVIATIONS: {
      title: 'Desviaciones de producción',
      description: 'Últimos cierres con diferencia exacta de rendimiento o consumo.',
    },
  },
  workflows: {
    title: 'Revisiones y aprobaciones',
    subtitle: 'Solo se muestran colas de acciones permitidas para su rol.',
    review: 'Revisión',
    approval: 'Aprobación',
    open: 'Abrir cola',
    none: 'Su rol no tiene colas de acciones asignadas.',
  },
  queues: {
    MATERIALS: 'Perfiles de material',
    RECIPES: 'Recetas y listas de materiales',
    PROCESS_ROUTINGS: 'Rutas de proceso',
    DECLARATIONS: 'Declaraciones',
    ANALYSIS: 'Perfiles de análisis',
    SPECIFICATIONS: 'Especificaciones de producto',
    LABELS: 'Plantillas de etiqueta',
    CHANGE_REQUESTS: 'Solicitudes de cambio',
  },
  recentRecipes: {
    title: 'Recetas modificadas recientemente',
    subtitle: 'Última versión editada de cada receta visible para su rol.',
    empty: 'No hay versiones de recetas disponibles.',
    number: 'Número',
    name: 'Receta',
    product: 'Producto de salida',
    version: 'Versión',
    status: 'Estado',
    changed: 'Modificada',
    open: 'Abrir receta {{number}}',
  },
  deviations: {
    title: 'Desviaciones de rendimiento y consumo',
    subtitle: 'Cierres recientes; los porcentajes se calculan exactamente en el servidor.',
    empty: 'No se registraron diferencias en el periodo actual de 30 días.',
    order: 'Orden',
    product: 'Producto',
    plannedActual: 'Plan / real',
    yield: 'Desviación de salida',
    material: 'Mayor desviación de material',
    reported: 'Registrada',
    unbounded: 'Sin límite (consumo con plan cero)',
    open: 'Abrir orden de producción {{number}}',
  },
  recipeStatuses: {
    DRAFT: 'Borrador',
    IN_REVIEW: 'En revisión',
    APPROVED: 'Aprobada',
    BLOCKED: 'Bloqueada',
    ARCHIVED: 'Archivada',
  },
} as const;
